<template>
  <div class="library-content-placeholder">
<!--    <div id="library-content" style="width: 100%"></div>-->
  </div>
</template>

<script>
import { start } from 'qiankun'
import { registerApps } from './config/index'
import common from "@common/common";
import { mapGetters } from 'vuex'

export default {
  name: 'unifiedContentLibrary',
  computed: {
    ...mapGetters('unifiedContentLibrary', ['getContentInstance']),
    contentInstance(){
      return this.getContentInstance
    }
  },
  methods: {
    getList() {
      console.log(765432)
    }
  },
  mounted() {
    if (!window.qiankunStarted) {
      window.qiankunStarted = true

      const parentInstance = {
        uploadClick: ()=>{
          this.$store.dispatch('unifiedContentLibrary/uploadBtnClick')
        },
        getUserKeys: ()=>{
          return common.userKeys()
        },
        getCommon: ()=>{
          return common
        },
        registerContentInstance: (instance)=>{
          this.$store.dispatch('unifiedContentLibrary/setContentInstance', {...this.contentInstance, ...instance})
        },
        updateUploadList: (list)=>{
          this.$store.dispatch('unifiedContentLibrary/setUploadList', list)
        },
        updateUploadStatus: (data)=>{
          this.$store.dispatch('unifiedContentLibrary/setUploadStatus', data)
        },
        toggleUploadModal: (val)=>{
          this.$store.dispatch('unifiedContentLibrary/setIsShowUploadModal', val)
        },
        setDetailInfo: (data, bool)=>{
          this.$store.dispatch('unifiedContentLibrary/setIsDetail', bool)
          this.$store.dispatch('unifiedContentLibrary/setDetailInfo', data)
        },
        getSystemConfig: ()=>{
          return this.$_syscfg
        },
        getThis: ()=>{
          return this
        }

      }
      registerApps(parentInstance,'/onlinePlayingLibrary')
      setTimeout(()=>{
        start({
          sandbox: {
            experimentalStyleIsolation: false // 样式隔离
          }
        })
      },1000)

    }
  }
}
</script>


